module.exports = __webpack_public_path__ + "img/user.ed52f187.svg";